
<template>
  <div>
    <div v-show="!noCauseDialog">
      <Navbar
        :appTitle="$route.query.type == 'edit' ? '处理' : '处理'"
        @ClickRight="$router.push('/application')"
      />
      <div
        class="search-content wrap-apply"
        :style="{
          top: GLOBAL.currentEnvironment ? '0' : '',
          paddingBottom: GLOBAL.currentEnvironment ? '132px' : '',
        }"
      >
        <van-cell-group style="margin-top: 20px">
          <p class="label FormTit required"><span></span>处理部门</p>
          <van-field
            readonly
            @click="userSelectVisible = true"
            v-model="buildForm.disposeDepartName"
            placeholder="请选择"
          />
          <div class="bottomLine"></div>
        </van-cell-group>

        <van-cell-group>
          <p class="label FormTit required"><span></span>处理方式</p>
          <scanInput  ref="scanInput2" :columns="disposeMethodList" placeholder="请选择"
          @changeScan="changeScan2" :isScan="false"/>
          <div class="bottomLine" style="margin-top: 2px"></div>
        </van-cell-group>
        <van-cell-group>
            <!-- {{buildForm.disposeTime}}==== -->
          <p class="label required FormTit"><span></span>处理时间</p>

          <van-field
            is-link
            readonly
            name="picker"
            v-model="buildForm.disposeTime"
            @click="timePickShow = true"
            placeholder="请选择"
          >
          </van-field>
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label FormTit"><span></span>处理描述</p>
          <van-field
            maxlength="500"
            type="textarea"
            v-model="buildForm.description"
            placeholder="请选择"
          />
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label FormTit"><span></span>附件</p>

          <file-selector
            ref="fileSelect"
            :maxCount="6"
            title="最多上传6个文件，大小不可超过20M"
            :fileIds="buildForm.attachments"
            @fileChange="fileChange"
          ></file-selector>
        </van-cell-group>

        <!-- <div class="jiange-line"></div> -->

        <div class="search-bottoms">
          <!-- <span class="btncancel" @click="btnConfirm(true)">继续报工</span> -->
          <!-- <span class="btnconfirm" @click="btnConfirm()">提交</span> -->
          <van-button
            @click="btnCancel"
            block
            color="#f6f6f6"
            :loading="subLoading"
            loading-text="加载中..."
          >
            <div style="color: #333; font-weight: 400">取消</div>
          </van-button>
          <van-button
            style="margin-left: 10px"
            @click="btnConfirm(null, true)"
            block
            color="#1890ff"
            :loading="subLoading"
            loading-text="加载中..."
          >
            <div style="color: #fff">
              {{ subBtnText }}
            </div>
          </van-button>
        </div>
      </div>

      <!--选择报工时间 -->
      <van-popup v-model="timePickShow" position="bottom">
        <van-datetime-picker
          @confirm="confirmPick"
          v-model="happenTime"
          @cancel="cancelPick"
          type="datetime"
          title="报工时间"
          :formatter="formatter"
        />
      </van-popup>

      <!--不合格项组件-->
      <unqualified-item-dialog
        ref="unqualifiedItemDialog"
        :unqualifiedItemList="unqualifiedItemList"
        @getValue="getValue($event)"
      ></unqualified-item-dialog>
      <!-- 操作按钮弹窗-->
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="processList"
          @cancel="showPicker = false"
          @confirm="onConfirm"
          value-key="key"
        />
      </van-popup>

      <!--检验人组件-->
      <contact-pickers
        type="2"
        :visible="userSelectVisible"
        @closePicker="userSelectVisible = false"
        @confirm="selectOperator"
      >
      </contact-pickers>
    </div>

    <!-- 不合格原因组件 -->
    <noCause
      ref="noCaseComp"
      :listData="buildForm.produceOrderReportWorkNonconformityDetailVoList"
      v-show="noCauseDialog"
      @noCauseConfirm="noCauseConfirm"
      @noCauseCancel="noCauseCancel"
    >
    </noCause>

    <!-- <PDAsao ref="pda" @changeScan="changeScan1" /> -->
  </div>
</template>
  <script>
// import { Tip } from "@/utils";
import moment from "moment";
import Navbar from "@/components/navBar/navBar_right";
import scanInput from "@/components/scanCode/scanInput";
import scanInputContact from "@/components/scanCode/scanInputContact";
import upload from "@/components/upload/upload";
import VanFieldSelectPicker from "@/components/ActionSheet/VanFieldSelectPicker";
import fileSelector from "@/components/fileSelector.vue";
import Examine from "@/components/examine";
import VanFieldCheckbox from "@/components/ActionSheet/VanFieldCheckbox";
import {
  processByBatchId,
  productionReportingAdd,
  productionTaskProcessMessage,
  workOrderDetailQueryById,
  workOrderList,
  scheduleById,
  produceOrderReportWorkQueryById,
  inspectionRecordAdd,
  produceOrderReportWorkWorkbench,
  taskListApi,
  produceOrderReportWorkWorkbenchProduce,
} from "@/api/productionApply";
import { formTypeExtendedFieldList } from "@/api/mobile";
import { inspectionTask } from "@/api/inspectionTask";
import { inspectionTaskqueryById } from "@/api/system";

import ContactPickers from "@/components/choiceuse/depart.vue";
import unqualifiedItemDialog from "@/views/workManagement/components/unqualifiedItemDialog.vue";
import { getUnqualifiedReasonList2, queryProcess } from "@/api/system";
import { basicNonconformityList } from "@/api/productionApply";
import noCause from "@/views/workManagement/productTask/noCause.vue";
import { Tip as Tips } from "@/utils";
import { getAction,postAction } from "@/api/manage";
//   import PDAsao from "./components/PDAsao.vue";
import FileSelector from "../../../components/fileSelector.vue";

export default {
  name: "newOutsourcingReport",
  components: {
    //   PDAsao,
    VanFieldCheckbox,
    unqualifiedItemDialog,
    ContactPickers,
    fileSelector,
    upload,
    VanFieldSelectPicker,
    Navbar,
    scanInput,
    Examine,
    noCause,
    scanInputContact,
    FileSelector,
  },
  data() {
    return {
        disposeMethodList:[],
      uninspectionNumber: "",
      subBtnText: "提交",
      subLoading: false,
      userIdList: [],
      realnameList: [],
      userIdScanList: [],
      detailInfo: {},
      sequentially: false,
      formTypeExtendedFields: [],
      happenTime: new Date(),
      timePickShow: false,
      noCauseDialog: false,
      unqualifiedItemDialog: false,
      showPicker: false,
      userSelectVisible: false, // 检验人选择组件
      buildForm: {
        unqualifiedNum: 0,
        qualifiedNum: "",
        extDataJson: {},
        userId: "",
      },
      unqualifiedItemModal: false, // 填写不合格项数量
      unqualifiedItemList: [], // 不合格项列表
      orderList: [],
      columns: [],
      processList: [],
      showScan: false,
    };
  },
  computed: {},
  beforeRouteLeave(to, from, next) {
    if (this.showPeopleSlect) {
      this.$refs.examine.closePicker();
      next(false);
    } else {
      next();
    }
  },
  async created() {
      await getAction("/jksaas-produce/produce/quality/unqualified/getDisposeMethod").then((res) => {
        this.disposeMethodList = res.result.map(
                      (item) => {
                        return {
                          label: item.text,
                          key: item.text,
                          value: item.value,
                          taskId: '',
                        }
                      }
                  );
      });


    this.buildForm.disposeTime = moment(new Date()).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    this.$forceUpdate()
    this.getInitData();



  },

  mounted() {},
  methods: {
    changeScan2(v){
        this.buildForm.disposeMethod = v.value
        console.log(v,'===')

    },
    selectDisposeMethod(){

    },
    // 只能输入不小于0的数字，最多16位，整数12位，小数4位
    validateInput(value, type) {
      if (!value) {
        this.$toast(type + "必填");
        return true;
      }
      // console.log('===============>',value,type)
      // 去除非法字符
      // value = value.replace(/[^\d.]/g, '');
      if (value.length > 1 && value.startsWith("0") && value !== "0") {
        this.$toast(type + "不能以0开头");
        return true;
      }
      // 检查小数点数量
      if ((value.match(/\./g) || []).length > 1) {
        this.isInvalid = true;
        this.$toast(type + "只能输入一个或零个小数点");
        return true;
      }

      // 检查小数部分长度
      if (value.includes(".") && value.split('.')[1] && value.split('.')[1].length > 4) {
        this.isInvalid = true;
        this.$toast(type + "小数部分不能超过4位");
        // this.errorMessage = '小数部分不能超过4位';
        return true;
      }

      // 检查是否为负数
      if (parseFloat(value) <= 0) {
        this.isInvalid = true;
        this.$toast(type + "只能输入大于0的数字");
        // this.errorMessage = '输入值不能为负数';
        return true;
      }

      // 检查总长度
      if (value.length > 16) {
        this.isInvalid = true;
        this.$toast(type + "总长度不能超过16位");
        // this.errorMessage = '总长度不能超过16位';
        return true;
      }

      // 验证通过
      return false;
    },
    // 红外扫码
    changeScan1(v, flag) {
      console.log(v, "vvvvvv");
      let EntityType = v.EntityType;
      let userid = v.userid;
      if (v.EntityType === "workOrder") {
        // 扫码之后清空下方数据
        this.processList = []; // 工单编号有变化时清空工序字段的内容
        this.buildForm.taskId = undefined;
        this.buildForm.qualifiedNum = 0;
        //工单码
        workOrderDetailQueryById({ id: v.id }).then((res) => {
          if (res.code == 200) {
            console.log("res.result", res.result);
            // 判断工单是否为“生产中”状态
            // 若判断为是，则把工单编号回显到当前表单。若判断不是“生产中”状态，则toast提示“工单状态不正确”；
            if (res.result.orderStatus == 1) {
              this.buildForm.orderCode = res.result.orderCode;
              this.buildForm.taskId = res.result.taskId;
              this.buildForm.goodsName =
                res.result.serialNumber +
                "|" +
                res.result.serialName +
                "|" +
                (res.result.serialSpecifications || "");
              this.$refs.scanInput.formData.key = res.result.orderCode; //回显工单
              this.$refs.scanInput.formData.value = res.result.taskId; //回显工单
              this.$forceUpdate();
              workOrderList({
                pageNo: 1,
                pageSize: 9999,
                orderCode: this.buildForm.orderCode,
              }).then((res) => {
                if (res.code == 200) {
                  this.buildForm.goodsName =
                    res.result.records[0].serialNumber +
                    " | " +
                    res.result.records[0].serialName +
                    " | " +
                    (res.result.records[0].serialSpecifications || "");

                  this.processList =
                    res.result.records[0].produceOrderTaskVo.map((item) => {
                      return {
                        label: item.processesName,
                        key: item.processesName,
                        value: item.processesId,
                        taskId: item.taskId,
                      };
                    });
                }
              });
            } else {
              this.buildForm.orderCode = "";
              this.$toast("工单状态不正确");
            }
          } else {
            this.$toast(res.message);
          }
        });
      } else if (EntityType === "productTask") {
        //任务二维码
        // 判断当前生产任务对应的生产工单状态是否为“生产中”
        // 若判断为是，则把工单编号、工序进行回显，且把对应的可报工数回显到合格数字段。若判断不是“生产中”状态，则toast提示“工单状态不正确”；
        this.processList = []; // 工单编号有变化时清空工序字段的内容
        this.buildForm.taskId = undefined;
        this.buildForm.qualifiedNum = 0;
        produceOrderReportWorkWorkbenchProduce({
          id: v.id,
        }).then((res) => {
          if (res.code == 200) {
            console.log("res.result", res.result);
            // 判断工单是否为“生产中”状态
            // 若判断为是，则把工单编号回显到当前表单。若判断不是“生产中”状态，则toast提示“工单状态不正确”；
            if (res.result.orderStatus == 1) {
              this.buildForm.orderCode = res.result.orderCode;
              this.buildForm.taskId = res.result.id;
              // this.$toast(res.result.id)
              this.$refs.scanInput.formData.key = res.result.orderCode; //回显工单
              this.$refs.scanInput.formData.value = res.result.id; //回显工单
              workOrderList({
                pageNo: 1,
                pageSize: 9999,
                orderCode: this.buildForm.orderCode,
              }).then((res) => {
                if (res.code == 200) {
                  this.buildForm.goodsName =
                    res.result.records[0].serialNumber +
                    " | " +
                    res.result.records[0].serialName +
                    " | " +
                    (res.result.records[0].serialSpecifications || "");

                  this.processList =
                    res.result.records[0].produceOrderTaskVo.map((item) => {
                      return {
                        label: item.processesName,
                        key: item.processesName,
                        value: item.processesId,
                        taskId: item.taskId,
                      };
                    });
                }
              });
            } else {
              this.buildForm.orderCode = "";
              this.$toast("工单状态不正确");
            }
          } else {
            this.$toast(res.message);
          }
        });
      } else if (v >= 0) {
        //数字条码
        // 若扫到数字条码，则把数字条码回显到合格数框，多次扫数字条码则自动拼接。
        // this.$toast(v)
        if (this.buildForm.qualifiedNum > 0) {
          let addStr = v + "";
          this.buildForm.qualifiedNum = this.buildForm.qualifiedNum + addStr;
        } else {
          this.buildForm.qualifiedNum = v + "";
        }
        this.buildForm.qualifiedNum = this.buildForm.qualifiedNum.substring(
          0,
          9
        );
      } else if (EntityType === "printTask" && userid) {
        //用户二维码
        // 扫用户二维码，则把用户回显到检验人字段，扫一个用户二维码则回显一个，多个姓名之间用“，”隔开。
        // 若扫到重复的用户二维码则toast提示“该用户已存在”。
        let users = this.buildForm.userId.split(",");
        if (!users.includes(userid) && this.buildForm.userId) {
          // this.buildForm.userId = this.buildForm.userId + ',' + v.userid
          this.$refs.scanInput3.formData.key = userid;
          this.$refs.scanInput3.formData.value = userid;
          getAction("/sys/user/queryById", { id: userid }).then((res) => {
            if (res.code == 200) {
              this.realnameList.push(res.result.realname);
              this.userIdList.push(res.result.id);
              this.buildForm.inspectedBy = this.realnameList.join(",");
              this.buildForm.userId = this.userIdList.join(",");
              this.$forceUpdate();
            }
          });
        } else if (!users.includes(userid) && !this.buildForm.userId) {
          // this.buildForm.userId = v.userid
          getAction("/sys/user/queryById", { id: userid }).then((res) => {
            if (res.code == 200) {
              this.realnameList.push(res.result.realname);
              this.userIdList.push(res.result.id);
              this.buildForm.inspectedBy = this.realnameList.join(",");
              this.buildForm.userId = this.userIdList.join(",");
              this.$forceUpdate();
            }
          });
        } else {
          this.$toast("该用户已存在");
        }
      } else if (!EntityType) {
        Tips.error("请扫正确的二维码");
      }
    },
    onInput(event, digitCount, fieldType) {
      let value = event + "";
      if (fieldType == 3 || fieldType == 4) {
        // 截断小数点后超过4位的部分
        if (value.includes(".")) {
          let parts = value.split(".");
          if (parts[1].length > 4) {
            value = parts[0] + "." + parts[1].substring(0, 4);
          }
        } else {
          value = event;
        }
        // 最大可以输入值
        if (digitCount <= 0) {
          throw new Error("Digit count must be a positive integer.");
        }
        let maxValue = Math.pow(10, digitCount) - 1 + 0.9999;
        if (value > maxValue) {
          value = maxValue;
          this.$toast("输入值超过允许输入最大值，已取值最大值");
        }
      }

      return value;
    },
    clearNoNumTwo(value, type, length) {
      if (type != 3 && type != 4) {
        return value;
      } else {
        return value.replace(/[^\d]/g, "");
      }
    },
    formatter(type, val) {
      console.log(type);
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      if (type === "hour") {
        return val + "时";
      }
      if (type === "minute") {
        return val + "分";
      }
      if (type === "second") {
        return val + "秒";
      }

      return val;
    },

    // 确定选择时间
    confirmPick(date) {
      this.buildForm.disposeTime = moment(date).format("YYYY-MM-DD HH:mm:ss");
      this.timePickShow = false;
    },
    // 取消选择时间
    cancelPick() {
      this.timePickShow = false;
    },
    noCauseConfirm(list, total) {
      this.noCauseDialog = false;
      this.buildForm.unqualifiedNum = total;
      this.buildForm.unqualifiedNotes = list
        .map((item) => item.nonconformityDescribe + ":" + item.num)
        .join(",");
      this.buildForm.produceOrderReportWorkNonconformityDetail = list.map(
        (item) => {
          return {
            nonconformityNum: item.num,
            nonconformityId: item.id,
          };
        }
      );
      this.$forceUpdate();
    },
    noCauseCancel() {
      this.noCauseDialog = false;
    },
    // 根据批次id获取对应批次下的工序
    getBatchList(id) {
      processByBatchId({ id }).then((res) => {
        let processList = res.result;
        //   找到sort最大值的工序，根据工序id查询对应工单的信息回填
        // 使用reduce方法查找最大排序值的项
        let maxItem = processList.reduce(function (prev, current) {
          return prev.sort > current.sort ? prev : current;
        });
        console.log(maxItem);
        this.buildForm.processName = maxItem.processesName;
        this.getOrderInfo(maxItem.id);
      });
    },
    getOrderInfo(id) {
      productionTaskProcessMessage({ id }).then((rst) => {
        console.log(rst);
        this.buildForm.orderId = rst.result.orderId;
        this.buildForm.orderCode = rst.result.orderCode;
        this.buildForm.goodsName =
          rst.result.goodsName + "-" + rst.result.goodsCode;
        this.buildForm.orderCode = rst.result.orderCode;
        this.buildForm.processName = rst.result.processesCode;
        this.buildForm.goodsName =
          rst.result.goodsName + "-" + rst.result.goodsCode;
        this.buildForm.orderId = rst.result.id;
        this.buildForm.goodsId = rst.result.goodsId;
        this.buildForm.goodsBasicUnit = rst.result.goodsBasicUnit;
        this.processList = rst.result.processList.map((item) => {
          return {
            label: item.processesName,
            key: item.processesName,
            value: item.id,
          };
        });
        // let scanObj = {
        //   id: this.buildForm.deviceId,
        //   orderCode: `${res.result.deviceCode}-${res.result.deviceName}`,
        // };
        // this.$refs.scanInput.propValue(scanObj);
      });
    },
    fillUnqualifiedItem() {
      this.noCauseDialog = true;
      // console.log(this.unqualifiedItemList, 'unqualifiedItemList')
      this.$refs.noCaseComp.initData(
        this.detailInfo.produceOrderReportWorkNonconformityDetailVoList
      );
    },
    getValue(query) {
      this.buildForm.unqualifiedQuantityNum = query.sum;
      this.buildForm.unqualifiedReason = query.sum2;
      this.buildForm.unqualifiedDtos = query.unqualifiedList.map((item) => {
        return {
          id: item.id,
          num: item.num,
        };
      });
    },
    onConfirm(a, b) {
      console.log(a, b, "ab");
      if (typeof a == "undefined") {
        this.showPicker = false;
        return;
      }
      this.buildForm.processId = a.value;
      this.buildForm.processName = a.key;
      this.showPicker = false;
    },
    handleChooseOperator(index, item) {
      this.currentIndex = index;
      this.userSelectVisible = true;
    },
    confirmOperator(v) {
      console.log(v);
      if (!v) {
        console.log(v);
        this.buildForm.userId = "";
        this.buildForm.inspectedBy = "";
        this.$forceUpdate();
      } else {
        console.log(2);
        this.buildForm.userId = v;
        this.buildForm.inspectedBy = v.join(",");
      }
    },

    selectOperator(val, selectedList) {
        console.log(val, selectedList,'val, selectedList')
      this.userSelectVisible = false;
      if (selectedList.length) {
        this.buildForm.disposeDepartId = val;
        this.buildForm.disposeDepartName = selectedList
          .map((item) => item.departName)
          .join(",");
      } else {
        this.buildForm.disposeDepartId = "";
        this.buildForm.disposeDepartName = "";
      }
    },
    //页面加载请求数据
    async getInitData() {
      const that = this;

    },

    changeScan(v, opratorType) {
      console.log(v, opratorType, "获取扫码组件数据");
      //value是下拉选择后值,code是扫码获得的值，根据qrcode判断是否隐藏当前页面只显示相机页
      if (opratorType == "select" && this.buildForm.orderId != v.value) {
        this.buildForm.orderId = v.value;
        this.buildForm.orderCode = v.key || "-";

        this.$refs.scanInput2.formData.value = undefined;
        this.$refs.scanInput2.formData.key = undefined;
        this.buildForm.processesId = "";
        this.buildForm.processesName = "";
        this.buildForm.taskId = "";

        workOrderList({
          pageNo: 1,
          pageSize: 9999,
          orderCode: this.buildForm.orderCode,
        }).then((res) => {
          if (res.code == 200) {
            this.buildForm.goodsName =
              res.result.records[0].serialNumber +
              " | " +
              res.result.records[0].serialName +
              " | " +
              (res.result.records[0].serialSpecifications || "");

            this.processList = res.result.records[0].produceOrderTaskVo.map(
              (item) => {
                return {
                  label: item.processesName,
                  key: item.processesName,
                  value: item.processesId,
                  taskId: item.taskId,
                };
              }
            );
          }
        });
      }
      if (opratorType == "scan") {
        console.log(v.code);
        if (v.code.EntityType !== "workOrder") {
          this.$toast("请扫正确二维码");
          return;
        }
        let obj = {
          id: v.code.id, //
        };
        workOrderList(obj).then((res) => {
          if (res.code == 200) {
            if (res.result.records[0].orderStatus != 1) {
              this.$toast("工单状态不正确");
              return;
            }
            this.buildForm.orderId = res.result.records[0].orderId;
            this.buildForm.orderCode = res.result.records[0].orderCode;

            this.$refs.scanInput2.formData.value = undefined;
            this.$refs.scanInput2.formData.key = undefined;

            this.$refs.scanInput.formData.value = res.result.records[0].orderId;
            this.$refs.scanInput.formData.key = res.result.records[0].orderCode;
            this.$refs.scanInput.showPicker = true;
            this.$refs.scanInput.showPicker = false;
            this.buildForm.goodsName =
              res.result.records[0].serialNumber +
              " | " +
              res.result.records[0].serialName +
              " | " +
              (res.result.records[0].serialSpecifications || "");

            this.processList = res.result.records[0].produceOrderTaskVo.map(
              (item) => {
                return {
                  label: item.processesName,
                  key: item.processesName,
                  value: item.processesId,
                  taskId: item.taskId,
                };
              }
            );
          }
        });
      }
    },

    changeScan4(v, opratorType) {
      // this.$toast('扫码进入')
      // 若扫到数字条码，则把数字条码回显到合格数框，多次扫数字条码则自动拼接。
      if (this.buildForm.qualifiedNum > 0) {
        let addStr = v.code + "";
        this.buildForm.qualifiedNum = this.buildForm.qualifiedNum + addStr;
      } else {
        this.buildForm.qualifiedNum = v.code + "";
      }
      this.buildForm.qualifiedNum =
        this.buildForm.qualifiedNum.substring(0, 9) * 1;
    },
    changeScan5(v, opratorType) {
      //用户二维码
      // 扫用户二维码，则把用户回显到检验人字段，扫一个用户二维码则回显一个，多个姓名之间用“，”隔开。
      // 若扫到重复的用户二维码则toast提示“该用户已存在”。
      let uid = v.code.userid;
      let users = this.buildForm.userId.split(",");
      if (!users.includes(uid) && this.buildForm.userId) {
        // this.buildForm.userId = this.buildForm.userId + ',' + v.userid
        this.$refs.scanInput3.formData.key = uid;
        this.$refs.scanInput3.formData.value = uid;
        getAction("/sys/user/queryById", { id: uid }).then((res) => {
          if (res.code == 200) {
            this.realnameList.push(res.result.realname);
            this.userIdList.push(res.result.id);
            this.buildForm.inspectedBy = this.realnameList.join(",");
            this.buildForm.userId = this.userIdList.join(",");
            this.$forceUpdate();
          }
        });
      } else if (!users.includes(uid) && !this.buildForm.userId) {
        // this.buildForm.userId = v.userid
        getAction("/sys/user/queryById", { id: uid }).then((res) => {
          if (res.code == 200) {
            this.realnameList.push(res.result.realname);
            this.userIdList.push(res.result.id);
            this.buildForm.inspectedBy = this.realnameList.join(",");
            this.buildForm.userId = this.userIdList.join(",");
            this.$forceUpdate();
          }
        });
      } else {
        this.$toast("该用户已存在");
      }
    },

    // 扫任务码进入逻辑

    changeScan3(v, opratorType) {
      if (opratorType == "scan") {
        console.log(v.code);
        if (v.code.EntityType !== "printTask") {
          this.$toast("请扫正确二维码");
          return;
        }

        if (this.userIdScanList.indexOf(v.code.userid) !== -1) {
          this.$toast("该用户已存在");
          return;
        } else {
          this.userIdScanList.push(v.code.userid);
        }

        getAction("/sys/user/queryById", { id: v.code.userid }).then((res) => {
          if (res.code == 200) {
            this.realnameList.push(res.result.realname);
            this.userIdList.push(res.result.id);
            this.buildForm.inspectedBy = this.realnameList.join(",");
            this.buildForm.userId = this.userIdList.join(",");
            this.$forceUpdate();
          }
        });
      }
    },
    fileChange(ids) {
      this.buildForm.attachments = ids;
      console.log("父组件" + ids); //你要保存的fileids
    },
    // 取消
    btnCancel() {
      this.$router.back();
    },
    // 提交
    btnConfirm(val, back) {
      if (!this.buildForm.disposeDepartName) {
        this.$toast("处理部门必填");
        return;
      }
      if (!this.buildForm.disposeMethod) {
        this.$toast("处理方式必填");
        return;
      }
      if (!this.buildForm.disposeTime) {
        this.$toast("处理时间必填");
        return;
      }

      this.handleSubmit(back);
    },
    handleSubmit(back) {
      let params = {
        ...this.buildForm,
      };

      if (this.$route.query.type == "edit") {
        //
        postAction('/jksaas-produce/produce/quality/unqualified/dispose',{
          ...params,
          id: this.$route.query.item.id,
        })
          .then((res) => {
            if (res.success) {
              this.$toast("成功");
              // this.$router.back()
            } else {
              this.$toast(res.message);
            }
          })
          .finally(() => {
            this.subLoading = false;
            if (back) {
              this.$router.back();
            }
          });
      } else {
        // 新增
        productionReportingAdd(params)
          .then((res) => {
            if (res.success) {
              this.$toast("报工成功");
              setTimeout(() => {
                if (!this.sequentially) {
                  // this.$router.back()
                  this.$router.push({
                    path: "/productTask/report",
                  });
                } else {
                  this.buildForm.disposeTime = moment(new Date()).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                  scheduleById({ id: this.buildForm.taskId }).then((res) => {
                    if (res.code == 200) {
                      // this.buildForm.qualifiedNum = res.result.reportWorkNum
                      this.buildForm.qualifiedNum =
                        res.result.reportWorkNum > 0
                          ? res.result.reportWorkNum
                          : 0;
                      this.$forceUpdate();
                    }
                  });
                }
              }, 500);
            } else {
              this.$toast(res.message);
            }
          })
          .finally(() => {
            this.subLoading = false;
            if (back) {
              this.$router.back();
            }
          });
      }
    },
  },
};
</script>
  <style lang="scss" scoped>
@import "@/assets/theme.scss";

.jiange-line {
  height: 20px;
  background-color: #f5f5f5;
}

.required span::after {
  left: -20px;
  top: 3px;
}

.search-content {
  position: fixed;
  top: 110px;
  width: 100%;
  height: calc(100vh - 200px);
  background: #fff;
  overflow: scroll;
  z-index: 99;
  padding-bottom: 50px;

  .formgroup {
    background: #ffffff;
    // padding: 0 0.16rem;
    margin-top: 20px;
    margin-bottom: 40px;
    padding-top: 20px;

    .title {
      width: 116px;
      height: 28px;
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #191f25;
      line-height: 10px;
      margin-left: 32px;
    }
  }
}

.bottomLine {
  height: 2px;
  background-color: #f0f0f0;
  margin: 0 32px;
}

.otherText {
  padding-bottom: 32px;
  font-size: 32px;
  font-weight: bold;
  color: #191f25;
}

.haveUnitBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding-right: 32px;

  /deep/ .van-cell {
    padding-right: 0;
    width: 520px;
  }

  /deep/ .van-field__control {
    max-width: 600px;
  }
}

/deep/ .van-nav-bar {
  z-index: 99;
}

.search-bottoms {
  width: 100%;
  height: 150px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0px;
  padding: 0 22px;
  box-sizing: border-box;
  font-size: 32px;
  font-weight: 500;
  z-index: 9;

  .btncancel {
    flex: 1;
    background: #f6f6f6;
    border: 2px solid rgba(25, 31, 37, 0.12);
    box-sizing: border-box;
    height: 78px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    margin-right: 22px;
    color: #191f25;
  }

  .btnconfirm {
    flex: 1;
    background: #1890ff;
    box-sizing: border-box;
    height: 79px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    color: #ffffff;
  }
}
</style>
